import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { usePageTitle } from '../lib/usePageTitle';

export default function NotFoundPage() {
  const navigate = useNavigate();
  usePageTitle('Page Not Found');

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex flex-col" data-testid="not-found-page">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-md text-center">
          <img src="/brand-icon.png" alt="617Reach" className="w-16 h-16 mx-auto mb-6 rounded-2xl shadow-md" />
          <p className="text-sm font-semibold tracking-[0.25em] text-[#C87D3E] uppercase mb-2">404</p>
          <h1 className="text-3xl font-bold text-[#1A1A1A] font-['Manrope'] mb-3">Looks like a wrong turn</h1>
          <p className="text-[#5A5A5A] mb-8 leading-relaxed">
            The page you're looking for isn't on our map — it may have moved, or the link may be incomplete.
            You're still on 617Reach, so let's get you back on route.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              data-testid="notfound-home-btn"
              onClick={() => navigate('/')}
              className="bg-[#5C4023] hover:bg-[#4A331C] text-white rounded-full h-11 px-6"
            >
              <Home className="w-4 h-4 mr-2" />Return Home
            </Button>
            <Button
              data-testid="notfound-search-btn"
              onClick={() => navigate('/')}
              variant="outline"
              className="border-[#E0D6C8] text-[#5C4023] hover:bg-[#F3EFE9] rounded-full h-11 px-6"
            >
              <Search className="w-4 h-4 mr-2" />Search Resources
            </Button>
            <Button
              data-testid="notfound-back-btn"
              onClick={() => navigate(-1)}
              variant="ghost"
              className="text-[#5A5A5A] hover:bg-[#F3EFE9] rounded-full h-11 px-6"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />Go Back
            </Button>
          </div>
        </div>
      </div>
      <img src="/skyline-band.jpg" alt="" aria-hidden="true" className="w-full max-h-36 object-cover object-top opacity-60 pointer-events-none select-none" />
    </div>
  );
}
